<template>
    <div class="rule_create">
        <div class="rule_create_header" :style="{width: fixWidth}">
            <el-button v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: `${titleText}托管(取消)` }" type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="closePage">取消</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px">{{titleText}}托管规则</span>
            <el-button v-if="isView" type="primary" class="mr20" @click="closePage">关闭</el-button>
            <el-popover
                v-else
                placement="right-start"
                :title="errorKpiList.length>0?'以下产品的对应KPI指标未维护，请维护后重试：':'存在以下问题点，请检查修改后重试：'"
                :width="errorKpiPlanList.length>0?'800':'400'"
                trigger="manual"
                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                v-model="popoverVisible">
                <div class="tip-list">
                    <div style="max-height: 400px;overflow-y: auto;" v-if="errorFormList.length>0">
                        <p v-for="(item, index) in errorFormList" :key="index">
                            {{index+1}}、{{item}}；
                        </p>
                    </div>
                    <div style="max-height: 400px;overflow-y: auto;" v-if="errorKpiList.length>0">
                        <p v-for="(item, index) in errorKpiList" :key="index">
                            {{index+1}}、{{item.msg||'-'}}；
                        </p>
                    </div>
                    <div style="max-height: 400px;overflow-y: auto;" v-if="errorKpiPlanList.length>0">
                        <h3 class="text-color-error font12px mb10">计划维度托管，仅支持计划下只有一个未删除的产品，以下计划包含多个投放产品：</h3>
                        <div class="mb10" v-for="account in errorKpiPlanList" :key="account.account_id">
                            <p>账户ID：{{account.account_id}}；账户名称：{{account.account_name}}</p>
                            <div class="ml20 plan-list">
                                <div v-for="plan in account.plan_list||[]" :key="plan.plan_id">
                                    <p>计划ID：{{plan.plan_id}}；计划名称：{{plan.plan_name}}</p>
                                    <div class="ml20 app-list">
                                        <p v-for="app in plan.app_list||[]" :key="app">
                                            产品名称：{{app}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="max-height: 400px;overflow-y: auto;" v-if="noAppList.length>0">
                        <h3 class="text-color-error font12px mb10">以下维度筛选中无产品，无法对比Kpi数据：</h3>
                        <p v-for="(item, index) in noAppList" :key="index">
                            {{index+1}}、{{item||'-'}}；
                        </p>
                    </div>
                    <div class="btn tac mt10" v-if="errorFormList.length>0||errorKpiPlanList.length>0||noAppList.length>0">
                        <el-button @click="hideErrPop" type="primary" size="mini"><span>关闭</span></el-button>
                    </div>
                    <div class="btn tac mt10" v-if="errorKpiList.length>0">
                        <el-button @click="hideErrPop" type="default" size="mini"><span>关闭</span></el-button>
                        <el-button @click="toKpiPage" type="primary" size="mini"><span>立即维护</span></el-button>
                    </div>
                </div>
                <el-button slot="reference" v-matomo="{behaviorCategory: '智能托管(托管规则)',  name: `${titleText}托管(保存)` }" :loading="submitLoading" type="primary" @click="submitData" >保存</el-button>
            </el-popover>
        </div>
        <div class="rule_create_body p20" :loading="pageLoading">
            <GoalInfo ref="goalInfo" :plat-list="allowedPlatList" :page-func="pageFuncConfig"  @updatePlat="updatePlat"/>
            <ConditionInfo ref="conditionInfo" :plat-id="plat_id"/>
            <ActionInfo ref="actionInfo" :plat-id="plat_id"/>
            <CheckInfo ref="checkInfo" />
            <NotifyInfo ref="notifyInfo" :notifier-config="notifierConfig"/>
            <NameInfo ref="nameInfo" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import GoalInfo from '../components/create/goalInfo';
    import ConditionInfo from '../components/create/conditionInfo';
    import ActionInfo from '../components/create/actionInfo/index.vue';
    import CheckInfo from '../components/create/checkInfo';
    import NotifyInfo from '../components/create/notifyInfo';
    import NameInfo from '../components/create/nameInfo';
    import {cloneDeep,uniq} from 'lodash';
    import API from '@/api/intelligent/intelligentManaged/index.js';


    export default {
        name: "CreatePage",
        components:{
            GoalInfo,
            ConditionInfo,
            ActionInfo,
            CheckInfo,
            NotifyInfo,
            NameInfo,
        },
        props:{
            allowedPlatList:Array,
            data:Object,
            type:String,
        },
        inject:['pageAction','pageFunc'],
        provide(){
            return {
                conditionOptionList: () => this.conditionOptionList,
                dimensionOptionList: () => this.dimensionOptionList,
                platId:()=>this.plat_id,
                appointed_time: () => this.appointed_time,
                max_num: () => this.max_num,
                max_range_time: () => this.max_range_time,
                condition_config: () => this.condition_config,
                validFormItem:(...data)=>this.validFormItem(...data),
                isView:this.isView,
                isEdit:this.isEdit,
                isCopy:this.isCopy,
                goalFormData:()=>this.goal_form_data,
                conditionFormData:()=>this.condition_form_data,
                global: this,
            }
        },
        data(){
            return {
                fixWidth: '1000px',
                pageLoading:false,
                submitLoading:false,
                plat_id:'',
                errorFormList:[],
                errorKpiList:[],
                errorKpiPlanList:[],
                noAppList:[],
                appointed_time:[],
                max_num:0,
                max_range_time:0,
                condition_config:[],
                operation_config:[],
                popoverVisible:false,

                viewNotifierList:[],
                viewFieldsList:[],
                viewDimensionList:[],
            }
        },
        computed:{
            ...mapGetters(['sidebar']),
            goal_form_data(){
                let $goalInfo = this.$refs.goalInfo;
                if($goalInfo){
                    let formData = $goalInfo.formData;
                    let oldData = {
                        oldDimension:$goalInfo.oldTempData.dimension,
                };
                    return Object.assign({},formData,oldData);
                }else{
                    return {};
                }
            },
            condition_form_data(){
                let $conditionInfo = this.$refs.conditionInfo;
                return $conditionInfo?$conditionInfo.formData:{};
            },
            pageActionConfig(){
                return this.pageAction();
            },
            pageFuncConfig(){
                return this.pageFunc();
            },
            notifierConfig(){
                if(this.isView) return this.viewNotifierList;
                let actionPage = this.pageActionConfig.find(item=>item.name=='intelligent_managed_rule')||{};
                return actionPage.notifier||[];
            },
            conditionOptionList(){
                let rulePage = this.pageActionConfig.find(item=>item.name=='intelligent_managed_rule');
                if(!rulePage) return [];

                let platFields = null;
                let platDimension = null;
                if(this.isView){
                    platFields = (this.viewFieldsList||[]).find(item=>item.name==('data_'+this.plat_id))||{};
                    platDimension = (this.viewDimensionList||[]).find(item=>item.name==('data_'+this.plat_id))||{};
                }else{
                    platFields = (rulePage.fields||[]).find(item=>item.name==('data_'+this.plat_id))||{};
                    platDimension = (rulePage.dimension||[]).find(item=>item.name==('data_'+this.plat_id))||{};
                }

                let fields = this._formatConfigData(cloneDeep(platFields)) ;
                return fields.children||[];
            },
            dimensionOptionList(){
                let rulePage = this.pageActionConfig.find(item=>item.name=='intelligent_managed_rule');
                if(!rulePage) return [];

                let platDimension = null;
                if(this.isView){
                    platDimension = (this.viewDimensionList||[]).find(item=>item.name==('data_'+this.plat_id))||{};
                }else{
                    platDimension = (rulePage.dimension||[]).find(item=>item.name==('data_'+this.plat_id))||{};
                }

                let dimension = this._formatConfigData(cloneDeep(platDimension));

                return dimension.children||[];
            },
            isView(){
                return this.type=='view';
            },
            isAdd(){
                return this.type=='add';
            },
            isCopy(){
                return this.type=='copy';
            },
            isEdit(){
                return this.type=='edit';
            },
            titleText(){
                if(this.isView) return '查看';
                if(this.isAdd) return '添加';
                if(this.isCopy) return '复制';
                if(this.isEdit) return '编辑';
                return '添加';
            },
        },
        watch:{
            sidebar: {
                handler(){
                    setTimeout(this.getFixWidth, 300)
                },
                deep:true,
            }
        },
        mounted() {
            this.getFixWidth();
            if(!this.isAdd){
                this.getRuleInfo();
            }
        },
        methods:{
            closePage(){
                if(this.isView) return this.$emit('changePage', 'RulePage', {});
                let dimension_config_data = this.$refs.goalInfo.formData.dimension_config_data||[];
                let curConNum = this.$refs.conditionInfo.curConNum;
                let conditions = this.$refs.conditionInfo.formData.conditions;
                let firstCondition = conditions.condition;
                if(Array.isArray(firstCondition)){
                    firstCondition = firstCondition[0];
                }
                let isAddCon = !!firstCondition.monitor_data.field||!!firstCondition.comparative_data.field||!!firstCondition.operator||!!firstCondition.comparison_value;
                if(dimension_config_data.length>0||curConNum>1||isAddCon){
                    let tip = '取消后当前编辑的内容不会被保存，确定要离开吗？';
                    this.$confirm(tip, '提示', {
                        confirmButtonText: '离开',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$emit('changePage', 'RulePage', {});
                    }).catch(() => {

                    });

                }else{
                    this.$emit('changePage', 'RulePage', {});
                }
            },
            getFixWidth(){
                let $createBody = document.querySelector('.rule_create_body');
                this.fixWidth = `${$createBody.clientWidth}px`;
            },
            updatePlat(data){
                this.plat_id = data;
                this.getConfig();
                let $conditionInfo = this.$refs.conditionInfo;
                if($conditionInfo){
                    $conditionInfo.setFirstCondition();
                }

            },
            validFormItem(data) {
                this.errorFormList.push(data);
            },
            async getConfig(){
                await API.getConfig({
                    plat_id:this.plat_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.appointed_time = resData.appointed_time||[];
                    this.max_num = resData.max_num||0;
                    this.max_range_time = resData.max_range_time||0;
                    this.condition_config = resData.condition||[];
                    this.operation_config = resData.operation_config||[];
                },err=>{
                    console.log('getConfig err',err)
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                })
            },
            submitData(){
                this.submitLoading = true;
                this.errorFormList = [];

                Promise.all([
                    this.$refs.goalInfo.validateFn(),
                    this.$refs.conditionInfo.validateFn(),
                    this.$refs.actionInfo.validateFn(),
                    this.$refs.checkInfo.validateFn(),
                    this.$refs.notifyInfo.validateFn(),
                    this.$refs.nameInfo.validateFn(),
                ]).then(async ([goalInfoForm,conditionInfoForm,actionInfoForm,checkInfoForm,notifyInfoForm,nameInfoForm])=> {
                    const params = {
                        plat_id: goalInfoForm.plat_id,
                        dimension: goalInfoForm.dimension,
                        dimension_config: goalInfoForm.dimension_config,
                        dimension_type: JSON.stringify(goalInfoForm.dimension_type),
                        // dimension_config_data: JSON.stringify(goalInfoForm.dimension_config_data),
                        dimension_config_data_id:goalInfoForm.dimension_config_data.map(item=>item.id).join(','),
                        conditions: JSON.stringify(conditionInfoForm.conditions),
                        

                        // trigger_action: actionInfoForm.trigger_action,
                        // trigger_action_max: actionInfoForm.trigger_action=='2'?actionInfoForm.trigger_action_max:'',
                        // trigger_action_type: actionInfoForm.trigger_action=='2'?actionInfoForm.trigger_action_type:'',
                       
                       
                        execute_time_frequency:checkInfoForm.check_type=='1'?'-1':checkInfoForm.execute_time_frequency,
                        execute_time_frequency_data:checkInfoForm.check_type=='1'?'':checkInfoForm.execute_time_frequency=='1'?checkInfoForm.weeks.join(','):checkInfoForm.execute_time_frequency=='5'?checkInfoForm.holidays.join(','):'',
                        execute_time_start:checkInfoForm.execute_time_start,
                        execute_time_end:checkInfoForm.execute_time_end,
                        check_frequency_time:checkInfoForm.check_frequency_time.join(','),
                        notification_way:notifyInfoForm.notification_way.join(','),
                        notification_user:notifyInfoForm.notification_user.join(','),
                        notification_designated_person:notifyInfoForm.notification_designated_person.join(','),
                        notification_designated_email:notifyInfoForm.notification_designated_email,
                        managed_name:nameInfoForm.managed_name,
                    };
                    // 仅通知
                    if(actionInfoForm.trigger_operation =='2') {
                        params.trigger_action = actionInfoForm.trigger_action;
                        params.trigger_action_max = actionInfoForm.trigger_action=='2'?actionInfoForm.trigger_action_max:'';
                        params.trigger_action_type = actionInfoForm.trigger_action=='2'?actionInfoForm.trigger_action_type:'';
                    }else {
                        params.operation_level = actionInfoForm.operation_level;
                        params.operation_items = actionInfoForm.operation_items;
                    };
                    params.trigger_operation = actionInfoForm.trigger_operation;

                    console.log('submit 111',params);
                    if(this.isEdit){
                        params.managed_id = this.data.managed_id;
                    }
                    try {
                        this.submitLoading = true;

                        let APIType = 'addRule';
                        if(this.isEdit){
                            APIType = 'editRule';
                        }
                        API[APIType]({...params}).then(res=>{
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            console.log('addRule',res);
                            this.$emit('changePage', 'RulePage', {},this.isEdit?'edit':'create');
                        },err=>{
                            console.log('addRule err',err);
                            this.submitLoading = false;

                            if (err.code == '403') {
                                this.$confirm(err.info||'请求异常', '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }

                            let errData = err.data||{};
                            let msgData = errData.err_list||[];
                            let kpiErrList = errData.kpi_err_list||[];
                            let kpiErrPlan = errData.err_plan||[];
                            let noApp = errData.no_app||[];
                            if(Array.isArray(msgData)&&msgData.length>0){
                                this.errorKpiList = [];
                                this.errorKpiPlanList = [];
                                this.noAppList = [];
                                this.errorFormList = msgData;
                                this.popoverVisible = true;
                            }else if(Array.isArray(kpiErrList)&&kpiErrList.length>0){
                                console.log('showKpiErrModal')
                                this.errorFormList = [];
                                this.errorKpiList = kpiErrList;
                                this.errorKpiPlanList = [];
                                this.noAppList = [];
                                this.popoverVisible = true;
                            }else if(Array.isArray(kpiErrPlan)&&kpiErrPlan.length>0){
                                this.errorFormList = [];
                                this.errorKpiList = [];
                                this.noAppList = [];
                                this.errorKpiPlanList = kpiErrPlan;
                                this.popoverVisible = true;

                            }else if(Array.isArray(noApp)&&noApp.length>0){
                                this.errorFormList = [];
                                this.errorKpiList = [];
                                this.errorKpiPlanList = [];
                                this.noAppList = noApp;
                                this.popoverVisible = true;

                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                        })
                    } catch (error) {
                        this.errorFormList = [error.info];
                        console.log(error,'error');
                    }

                }).catch((err)=> {
                    console.log(err,'err err');
                    this.submitLoading = false;
                    this.popoverVisible = true;
                })
            },
            hideErrPop(){
                this.popoverVisible = false;
                this.errorFormList = [];
                this.errorKpiList = [];
            },
            toKpiPage(){
                console.log('toKpiPage',this.errorKpiList);

                let kpiErrData = this.errorKpiList.map(item=>item.id).filter(item=>!!item);
                if(kpiErrData.length<=0) return this.$message.error('数据有误，页面跳转失败');

                let cid = new Date().getTime();
                let $router= this.$router.resolve({
                    name:'app_kpi_'+this.plat_id,
                    query:{
                        // app_id: kpiErrData,
                        query_app:cid,
                    },
                });
                localStorage.setItem("intelligentRuleApp_"+cid, JSON.stringify(uniq(kpiErrData)));
                window.open($router.href, '_blank');
            },
            async updateFormData(formData){
                await this.$refs.goalInfo.setFormData(formData);

                this.$refs.actionInfo.setFormData(formData);
                this.$refs.checkInfo.setFormData(formData);
                this.$refs.notifyInfo.setFormData(formData);
                this.$refs.nameInfo.setFormData(formData);
                this.$refs.conditionInfo.setFormData(formData);
            },
            getRuleInfo(){
                console.log('getRuleInfo',this.data,this.data.managed_id);

                let APIType = 'getRuleInfo';
                if(this.isCopy){
                    APIType = 'getCopyRuleInfo';
                }

                let id = this.data.managed_id;
                API[APIType]({
                    managed_id:id,
                }).then(async res=>{
                    console.log('getRuleInfo',res);
                    let resData = res.data||{};
                    this.plat_id = resData.plat_id;
                    await this.getConfig();
                    this.updateFormData(resData);

                    if(this.isView){
                        this.viewFieldsList = resData.fields_list||[];
                        this.viewDimensionList = resData.dimension_list ||[];
                        this.viewNotifierList = resData.notifier_list ||[];
                    }
                },err=>{
                    console.log('getRuleInfo err',err);
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                })
            },
            _formatConfigData(data){
                if(data.config&&typeof data.config==='string'){
                    data.config = JSON.parse(data.config);
                }
                let children = data.children;
                if(children&&children.length>0){
                    children.forEach(item=>{
                        this._formatConfigData(item);
                    })
                }
                return data;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .rule_create{
        position: relative;
        padding: 10px 20px;
        &:before{
            content: '';
            position: fixed;
            display: block;
            left: 0;
            right: 0;
            width: 100%;
            height: 10px;
            background-color: #f1f4f9;
            z-index: 2;
            top: 50px;
        }
    }
    .rule_create_header{
        background-color: #fff;
        padding: 4px 8px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        position: fixed;
        top: 60px;
        z-index: 3;
        box-shadow: 0px 1px 2px #d9d9d9;
        .text {
            display:inline-block;
            line-height: 32px;
        }
    }

    .rule_create_body{
        margin-top: 52px;
        background-color: #fff;
        min-height:  calc(100vh - 100px);

        ::v-deep .el-form-item__error{
            word-break: break-all;
        }
    }
</style>
